import { Props_SnippetIntro } from './Intro.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SharedHeading from "../Shared/Heading/Heading";
import SnippetLink from "../Shared/Link/Link";

const SnippetIntro = (props: Props_SnippetIntro) => {
    const { heading, contents, repeatable_link, background } = props
    
    const classContentIntroParagraph: string = contents.intro?.value ? 'snippet-content__content--intro' : ''
    
    // Handle heading text with backward compatibility
    const headingText = heading.text?.value || (heading as {content?: {value?: string}}).content?.value
    
    // Determine visibility state
    const isVisible = typeof heading.visibility?.value === 'boolean' ? heading.visibility.value : heading.visibility?.value === 'true'
    
    // Build heading class name with snippet-specific visibility classes  
    let headingClassName = 'snippet-content__heading'
    if (isVisible) {
        headingClassName += ' snippet-content__heading--visible'
    }

    // Alignment for heading and content (paragraph follows header)
    const validAlignments = ['start', 'center', 'end']
    const alignment = validAlignments.includes(heading.alignment?.value as string) 
        ? heading.alignment.value 
        : 'center'
    const alignmentModifier = `snippet-content--${alignment}`

    const headingLevel = heading.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h2';

    const backgroundClass = background?.background?.value ? `snippet-content--${background.background.value}` : '';

    return (
        <section className={`snippet-content ${alignmentModifier} ${backgroundClass}`}>
            <div className="snippet-content__container">
                <SharedHeading
                    className={headingClassName}
                    level={headingLevel}
                    alignment={
                        heading.alignment?.value === "start" ||
                        heading.alignment?.value === "center" ||
                        heading.alignment?.value === "end"
                            ? heading.alignment.value
                            : undefined
                    }
                    visibility={isVisible}
                >
                    {headingText}
                </SharedHeading>
            
                <div className={`snippet-content__content ${classContentIntroParagraph}`}>
                    { contents?.text?.value && CompileMarkdown(contents.text.value) }
                </div>
                <div className="snippet-content__container-links">
                    { repeatable_link.map((link, index) => (
                        <SnippetLink
                            key={`snippet-content-${index}-link`}
                            className="snippet-content__link"
                            linkStyles={typeof link.linkStyle?.value === 'string' ? link.linkStyle.value : "primary"}
                            url={typeof link.linkHref?.value === 'string' ? link.linkHref.value : undefined}
                            openInNewTab={typeof link.linkTarget?.value === 'boolean' ? link.linkTarget.value : link.linkTarget?.value === 'true'}
                        >
                            {link.linkText?.value}
                        </SnippetLink>
                    ))}
                </div>
            </div>
        </section>
    )}

export default SnippetIntro
